import React, { useState, useEffect } from "react";
import ReBiddingDialog from "../ReBiddingDialog";
import RadioGroup from "../../atoms/RadioGroup";
import Input from "../../atoms/Input";
import Button from "../../atoms/Button";
import { ListPopUpPostApi } from "../../../utils/API/ListPopUpPostApi";
import { useDispatch } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import { taxationAmount } from "../../../utils/API/taxationAmount";
import toast from "react-hot-toast";

const status = [
  { label: "Partially", value: "partially" },
  { label: "Fully", value: "fully" },
];

const ListPopUp = ({
  open,
  onCancel,
  selectedRowData,
  onListPopUpOk,
  selectedColumns,
  schemaType,
}) => {
  const dispatch = useDispatch();
  const [numberOfCredits, setNumberOfCredits] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("partially");
  const [pricePerCredit, setPricePerCredit] = useState(null);
  const [creditsErrorMsg, setCreditsErrorMsg] = useState("");
  const [priceErrorMsg, setPriceErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const [amount, setAmount] = useState(0);
  const [gst, setGst] = useState(0);
  const [platformFee, setPlatformFee] = useState(0);
  const [remittance, setRemittance] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
    if (event.target.value === "fully") {
      setNumberOfCredits(selectedRowData["Number Of Credits"]);
    } else {
      setNumberOfCredits(0);
    }
  };

  const handleNumberOfCreditsChange = (event) => {
    const inputCredits = parseInt(event.target.value, 10);
    if (selectedStatus === "fully") {
      setNumberOfCredits(selectedRowData["Number Of Credits"]);
    } else {
      setNumberOfCredits(
        Math.min(inputCredits, selectedRowData["Number Of Credits"])
      );
    }
  };

  const handleListPopUpOk = async () => {
    const newFormData = {
      projectId: selectedRowData["Project Id"],
      pricePerCredit: pricePerCredit,
      creditsTosell: numberOfCredits,
      creditTransaction: selectedStatus,
    };

    if (numberOfCredits <= 0 || pricePerCredit <= 0) {
      if (numberOfCredits <= 0) {
        setCreditsErrorMsg("Number of Credits should be greater than 0");
      }
      if (pricePerCredit <= 0) {
        setPriceErrorMsg("Price Per credit should be greater than 0");
      }
    } else {
      try {
        setLoading(true);
        await ListPopUpPostApi(newFormData.projectId, newFormData, dispatch);
        setCreditsErrorMsg("");
        setNumberOfCredits("");
        setPriceErrorMsg("");
        setPricePerCredit("");
        setSelectedStatus("partially");
        onListPopUpOk();
      } catch (error) {
        console.error("Error listing project:", error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (
      numberOfCredits &&
      numberOfCredits &&
      numberOfCredits !== 0 &&
      pricePerCredit !== 0 &&
      numberOfCredits !== "" &&
      pricePerCredit !== ""
    ) {
      fetchTaxationData();
    } else {
      setAmount(0);
      setGst(0);
      setPlatformFee(0);
      setRemittance(0);
      setTotalAmount(0);
    }
  }, [numberOfCredits, pricePerCredit, selectedStatus]);

  const fetchTaxationData = async () => {
    try {
      const formData = {
        buyerOrigin: "NAT",
        sellerOrigin: "NAT",
        totalAmount: numberOfCredits * pricePerCredit,
      };
      const amounts = await taxationAmount(formData, dispatch);
      setAmount(formData.totalAmount);
      setGst(amounts.data.data.tax);
      setPlatformFee(amounts.data.data.platform_fee);
      setRemittance(amounts.data.data.remittance);
      const calculatedTotalAmount =
        formData.totalAmount -
        (amounts.data.data.tax +
          amounts.data.data.platform_fee +
          amounts.data.data.remittance);
      setTotalAmount(calculatedTotalAmount);
    } catch (error) {
      toast.error("Error in Fetching Taxes and amounts Balance");
    } finally {
    }
  };

  const handleCancel = () => {
    setCreditsErrorMsg("");
    setNumberOfCredits("");
    setPriceErrorMsg("");
    setPricePerCredit("");
    setSelectedStatus("partially");
    onCancel();
  };

  return (
    <ReBiddingDialog
      open={open}
      onCancel={handleCancel}
      selectedRowData={selectedRowData}
      onListDailogOk={onListPopUpOk}
      selectedColumns={selectedColumns}
      schemaType={schemaType}
    >
      <div className="px-12 py-2">
        <div className="font-bold">
          <RadioGroup
            options={status}
            onChange={handleStatusChange}
            value={selectedStatus}
          />
        </div>
      </div>
      <div className="flex justify-between bg-blue-100 px-12 py-3">
        <label className="text-lg font-bold">Credits to Sell</label>
        <Input
          type="number"
          variant="secondary"
          className="inline-block w-28"
          placeHolder={0}
          value={numberOfCredits}
          onChange={handleNumberOfCreditsChange}
          disabled={selectedStatus === "fully" ? true : false}
        />
        <label className="text-lg font-bold">Price Per Credit</label>
        <Input
          type="number"
          variant="secondary"
          className="inline-block w-28 text-lg"
          value={pricePerCredit}
          onChange={(e) => setPricePerCredit(e.target.value)}
        />
      </div>
      <div className="flex justify-between bg-blue-100 px-12 py-3">
        <p className="text-red-500 text-bold text-sm">{creditsErrorMsg}</p>
        <p className="text-red-500 text-bold text-sm">{priceErrorMsg}</p>
      </div>
      <div className="px-12 py-2">
        <div className=" text-xs text-gray-400">
          <p>Amount = ${amount?.toFixed(2)}</p>
          <p>Tax = ${gst?.toFixed(2)}</p>
          <p>Remittance = ${remittance?.toFixed(2)}</p>
          <p>Platform Fee = ${platformFee?.toFixed(2)}</p>
        </div>
        <p className="text-sm">Total Fund Earn - ${totalAmount?.toFixed(2)}</p>
        <Button
          variant="primary"
          color="blue"
          className="mt-2 text-base px-20 rounded-md py-3 text-white font-bold mx-auto block"
          onClick={async () => {
            await handleListPopUpOk();
          }}
          disabled={loading}
        >
          <div className="flex justify-center">
            {loading ? <LoadingOutlined /> : "List"}
          </div>
        </Button>
      </div>
    </ReBiddingDialog>
  );
};

export default ListPopUp;
